import * as React from "react";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";

import { useAppSelector } from "../../redux/store.ts";
import { addOptionDialogFactory, isAddNewVehicleTarget } from "./common.tsx";
import {
  api,
  VehicleCreate,
  CreateVehicleApiVehiclesPostApiArg,
  CreateVehicleApiVehiclesPostApiResponse,
} from "../../api";

type VehicleEditFormProps = {
  formContent: VehicleCreate;
  setFormContent: React.Dispatch<React.SetStateAction<VehicleCreate>>;
  lockType?: boolean;
};

const VehicleEditForm = ({
  formContent,
  setFormContent,
  lockType = false,
}: VehicleEditFormProps) => (
  <>
    <div className="field">
      <label>
        Numer rejestracyjny <span style={{ color: "red" }}> *</span>
      </label>
      <InputText
        value={formContent.number}
        onChange={(e) =>
          setFormContent((prev) => ({
            ...prev,
            number: e.target.value,
          }))
        }
        className="w-full"
        placeholder="Wpisz numer rejestracyjny"
      />
    </div>
    <div className="field">
      <label>
        Typ pojazdu
        <span style={{ color: "red" }}> *</span>
      </label>
      <div className="add-new-type-selector">
        <div className="flex-container">
          <RadioButton
            inputId="type_truck"
            name="type"
            value="truck"
            checked={formContent.type === "truck"}
            onChange={() =>
              setFormContent((prev) => ({
                ...prev,
                type: prev.type === "trailer" ? "truck" : "trailer",
              }))
            }
            disabled={lockType}
          />
          <label htmlFor="type_truck" className="ml-2">
            Ciągnik
          </label>
        </div>
        <div className="flex-container">
          <RadioButton
            inputId="type_trailer"
            name="type"
            value="trailer"
            checked={formContent.type === "trailer"}
            onChange={() =>
              setFormContent((prev) => ({
                ...prev,
                type: prev.type === "trailer" ? "truck" : "trailer",
              }))
            }
            disabled={lockType}
          />
          <label htmlFor="type_trailer" className="ml-2">
            Naczepa
          </label>
        </div>
      </div>
    </div>
  </>
);

const emptyVehicle = {
  type: "truck",
  number: "",
} as const satisfies VehicleCreate;

const VehicleAddOptionDialog = addOptionDialogFactory<
  VehicleCreate,
  CreateVehicleApiVehiclesPostApiArg,
  CreateVehicleApiVehiclesPostApiResponse,
  VehicleEditFormProps
>({
  defaultValues: emptyVehicle,
  FormComponent: VehicleEditForm,
  useMutation: api.endpoints.createVehicleApiVehiclesPost.useMutation,
  createMutationArg: (formContent) => ({ vehicleCreate: formContent }),
  validate: (formContent) => !!(formContent.number && formContent.type),
  headerText: "Edytuj pojazd",
  makeFormProps: ({ initialValues }) => ({
    lockType: initialValues?.type !== undefined,
  }),
});

export const VehicleAddOption: React.FC = () => {
  const { target } = useAppSelector((state) => state.addNew);
  if (!isAddNewVehicleTarget(target)) {
    return null;
  }
  return (
    <VehicleAddOptionDialog
      rowId={target.id}
      field={target.field}
      initialValues={target.initialValues}
    />
  );
};
